<template>
  <div class="invoice_detail_wrapper">
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <el-image :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">发货单号：{{ arrivalCode }}</span>
                <span :class="`status-${arrivalSts}`">
                {{ convertToName(executionStatusGroup, arrivalSts) }}
                </span>
              </div>
              <div class="customer">{{ unit }}</div>
            </div>
          </div>
          <el-tabs v-model="activeKey" @change="handleActiveChange">
            <el-tab-pane label="发货单信息" name="1"></el-tab-pane>
            <el-tab-pane label="日志动态" name="2"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">物流信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="物流公司">{{ info.logistics.logisticsCompanyName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="物流单号">
              <div @click="handleShowExpressDialog" style="color: #237FFA; cursor: default;">
                {{ info.logistics.code | setEmpty }}{{ info.latestExpress }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12 flex-group">
            <span>发货物资信息</span>
            <span class="right">关联销售单号：<b @click="toOrder" style="color: #1890ff;cursor: default;font-weight: normal;">{{ orderCode }}</b></span>
          </div>
          <TableWithPagination :columnList="columnList2" :tableData="info.deliveryGoodsList" />
        </div>
        <div class="common">
          <div class="title gap-12">收货人信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="姓名">{{ info.receiverName | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ info.receiverPhone | setEmpty }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{ info.detailAddress | setEmpty }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">附件信息</div>
          <el-form inline>
            <el-form-item label="随货同行单">
              <template v-if="attchList.length">
                <el-image
                  v-for="(item, index) in attchList"
                  :key="index"
                  style="width: 80px; height: 80px;margin-right: 10px; margin-bottom: 10px; border: 1px solid #DFE2E8; border-radius: 4px;"
                  :src="item"
                  :preview-src-list="attchList">
                </el-image>
              </template>
              <template v-else>
                <span>未上传</span>
              </template>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common">
          <TableWithPagination :columnList="logColumns" :tableData="logData" />
        </div>
      </template>
    </div>

    <ExpressDialog ref="expressDialogRef" />

    <BottomPanel>
      <el-button type="default" @click="() => $router.back()" >返回</el-button>
    </BottomPanel>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { deliveryDetail, queryKuaiDi100Detail } from '@/api/invoiceMgr';
import { orderLogs } from '@/api/pickUpOrders';
import ExpressDialog from '@/components/expressDialog.vue';
import { dateFormat } from '@/utils/dateFormat.js';
import * as Moment from 'dayjs';

const executionStatusGroup = [
  // {
  //   label: '待收货',
  //   value: 1,
  // },
  // {
  //   label: '部分收货',
  //   value: 2,
  // },
  // {
  //   label: '已收货',
  //   value: 3,
  // },
  // {
  //   label: '已取消',
  //   value: 4,
  // },
  {
    label: '已发货',
    value: 1,
  },
  {
    label: '已取消',
    value: 2,
  },
];

export default {
  name: 'invoice_detail',
  mixins: [TablePaginationMixin],
  components: {
    ExpressDialog,
    TableWithPagination,
  },
  props: {
    id: {
      type: String,
    },
    arrivalCode: {
      type: String,
    },
    orderId: {
      type: String,
    },
    orderCode: {
      type: String,
    },
    arrivalSts: {
      type: [String, Number],
    },
    unit: {
      type: String,
    },
    tenantId: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'), // eslint-disable-line
      activeKey: '1',
      attchList: [],
      executionStatusGroup,
      info: {
        logistics: {},
      },
      columnList2: [
        {
          label: '商品编码',
          prop: 'skuCode',
          tooltip: true,
        },
        {
          label: '商品名称',
          prop: 'goodsName',
          tooltip: true,
        },
        {
          label: '规格',
          prop: 'specification',
          tooltip: true,
        },
        {
          label: '型号',
          prop: 'model',
          tooltip: true,
        },
        {
          label: '品牌名称',
          prop: 'brandName',
          tooltip: true,
        },
        {
          label: '生产商',
          prop: 'manufacturer',
          tooltip: true,
        },
        {
          label: '厂家编码',
          prop: 'factoryCode',
          tooltip: true,
        },
        {
          label: '发货数量',
          prop: 'quantity',
          tooltip: true,
        },
        {
          label: '生产日期',
          prop: 'productionDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['productionDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '失效日期',
          prop: 'expiryDate',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', this.formateDate(row['expiryDate'], 'YYYY-MM-DD'));
          },
        },
        {
          label: '生产批次号',
          prop: 'batchNo',
          tooltip: true,
        },
        {
          label: '生产序列号',
          prop: 'serialNo',
          tooltip: true,
        },
        {
          label: '是否医疗件',
          prop: 'medicalFlag',
          tooltip: true,
          render: (h, { row }) => {
            return h('span', row.medicalFlag ? '是' : '否');
          },
        },
        {
          label: '注册证号',
          prop: 'certificateNumber',
          tooltip: true,
        },
      ],
      logData: [],
      logColumns: [],
      logColumns2: [
        {
          prop: 'eventTypeDesc',
          label: '事项类型',
          width: '300px',
          tooltip: true,
        },
        {
          prop: 'createTime',
          label: '时间',
          width: '300px',
          tooltip: true,
          format: (val) => val && dateFormat(val).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          prop: 'content',
          label: '日志内容',
          tooltip: true,
        },
      ],
    };
  },
  created () {
    this.getDetail();
    this.getLog();
  },
  methods: {
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    toOrder () {
      this.$router.push({
        path: '/saas/pickUpOrders/detail',
        query: {
          id: this.orderId,
          orderCode: this.orderCode,
          tenantId: this.tenantId,
        },
      });
    },
    async handleShowExpressDialog () {
      if (!this.info?.logistics?.code) return;
      this.$refs.expressDialogRef.transportCode = this.info.logistics.code;
      this.$refs.expressDialogRef.info.logisticsCompany = this.info.logistics.logisticsCompanyName;
      this.$refs.expressDialogRef.info.logisticsCode = this.info.logistics.code;

      const { body } = await queryKuaiDi100Detail({ com: this.info.logistics.logisticsCompanyCode, num: this.info.logistics.code });
      const data = (body?.logisticsTrackList || []).map(i => ({
        context: i.context,
        recordTime: i.fTime,
      }));
      this.$refs.expressDialogRef.info.recordList = data;
      this.$refs.expressDialogRef.dialogVisible = true;
    },
    async handleCopy () {
      try {
        await navigator.clipboard.writeText(this.info.logistics.code);
        this.$message({
          type: 'success',
          message: '文本已成功拷贝到剪贴板',
          duration: 1000,
        });
      } catch (err) {
        console.error('无法拷贝文本: ', err);
      }
    },
    formateDate (date, format) {
      if (!date) {
        return '--';
      } else {
        return Moment(date).format(format);
      }
    },
    getLog () {
      this.logColumns = this.logColumns2;
      orderLogs({
        businessId: this.id,
        businessType: 'SALE_DELIVERY',
        module: 'SALE',
        orderBy: [{
          orderByType: 'DESC',
          orderByProperty: 'lastUpdateTime',
        }],
        pageFlag: false,
      }).then(({ body }) => {
        this.logData = body?.list || [];
      });
    },
    getDetail () {
      deliveryDetail({ id: this.id, findAccompanyBillFlag: true, findDeliveryGoodsFlag: true, findLogisticsFlag: true, tenantId: this.tenantId, findDeliveryGoodsSerialFlag: true, findOrderFlag: true }).then(({ body }) => {
        let { accompanyBillList } = body;
        body.detailAddress = `${body.receiverProvinceName || ''}${body.receiverCityName || ''}${body.receiverAreaName || ''}${body.receiverDetailAddress || ''}` || '--';
        this.attchList = accompanyBillList.map((i) => (i.url)) || [];
        body.deliveryGoodsList = (body.deliveryGoodsList || []).map(i => {
          let deliveryGoodsSerial = {};
          if (i.deliveryGoodsSerialList?.length) {
            deliveryGoodsSerial = i.deliveryGoodsSerialList[0];
          }
          return {
            ...i,
            productionDate: deliveryGoodsSerial.productionDate,
            expiryDate: deliveryGoodsSerial.expiryDate,
            batchNo: deliveryGoodsSerial.batchNo,
            serialNo: deliveryGoodsSerial.serialNo,
          };
        });
        this.info = body;
        this.info.logistics = body?.logisticsList?.length ? body.logisticsList[0] : {};
        this.info.latestExpress = null;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.invoice_detail_wrapper {
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }
    .flex-group {
      display: flex;
      justify-content: space-between;
      .right {
        font-weight: normal;
        color: #606266;
      }
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              // .status-1,
              // .status-2 {
              //   @include tag_round();
              //   background-color: #E2F3FE;
              //   color: #237FFA;
              // }

              .status-2 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-1 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }
}
</style>
